"use client"

import { Layout } from 'antd'
import BasicLayoutFooterSkeleton from './BasicLayoutFooter.skeleton'
import BasicLayoutHeaderSkeleton from './BasicLayoutHeader.skeleton'

const BasicLayoutSkeleton = () => {

  return (
    <Layout
      className='basic_layout' 
    // style={{ position: 'fixed', height: '100vh', width: '100vw', top: 0, left: 0, zIndex: 100, background: '#ffffff' }}
    >
      <BasicLayoutHeaderSkeleton />
      <Layout.Content style={{ alignSelf: 'stretch' }} />
      <BasicLayoutFooterSkeleton />
    </Layout>
  )
}

export default BasicLayoutSkeleton